import {
  wrapRootElement as rootElement,
  wrapPageElement as pageElement
} from './root';

export const wrapRootElement = rootElement;
export const wrapPageElement = pageElement;
